
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Tooltip,
    TextField,
    Snackbar,
    Alert,
    Popover
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import CallIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {useTheme} from '@mui/material/styles';
import {BaseRecordModel,
        OutputFieldScreenElementModel} from '../../models/modelsFlow';
import {validateEmailField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const OutputFieldElementComponent: React.FC<{
  element: OutputFieldScreenElementModel
}> = ( {
  element
}) => {

  const [openPopover, setOpenPopover] = useState(false);
  const anchorRef = useRef(null);

  const styles = ContainerClasses();

  const handleCopyClick = () => {
    const textToCopy = element.value ?? "";
    navigator.clipboard.writeText(textToCopy);
    setOpenPopover(true);
    setTimeout(() => setOpenPopover(false), 1500);
  }


  return (
    <>
      <TextField
         fullWidth
         disabled={true}
         size="small"
         label={element.label}
         variant="filled"
         value={element.value}
         InputProps={{
           disableUnderline: true,
           endAdornment: (
              <InputAdornment position="end">
                  <IconButton ref={anchorRef} size="small" onClick={() => handleCopyClick()}>
                    <ContentCopyIcon fontSize="small"/>
                  </IconButton>
            </InputAdornment>
          )
         }}
      />

      <Popover
        open={openPopover}
        anchorEl={anchorRef.current}
        onClose={() => setOpenPopover(false)}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
        transformOrigin={{ vertical: "top", horizontal: "left"}}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2
          }
        }}
      >
        <Typography variant="body2">
          Copied
        </Typography>
      </Popover>
    </>
    );

};
